import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLoader, FiCheckCircle, FiZap } = FiIcons;

const LoadingSpinner = () => {
  const loadingSteps = [
    { icon: FiLoader, text: 'Initializing Systems' },
    { icon: FiZap, text: 'Calibrating Drones' },
    { icon: FiCheckCircle, text: 'Ready for Launch' }
  ];

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-slate-900">
      <div className="text-center max-w-md">
        <div className="relative mb-8">
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
            className="w-24 h-24 mx-auto"
          >
            <div className="w-full h-full rounded-full border-4 border-green-400/20 border-t-green-400"></div>
          </motion.div>
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            className="absolute inset-0 flex items-center justify-center"
          >
            <SafeIcon icon={FiZap} className="text-3xl text-green-400" />
          </motion.div>
        </div>

        <motion.h2
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="text-3xl font-bold text-white mb-3"
        >
          Drone Cleaning Technologies
        </motion.h2>

        <div className="space-y-3">
          {loadingSteps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.3 + index * 0.3 }}
              className="flex items-center gap-3 text-slate-300"
            >
              <SafeIcon icon={step.icon} className="text-green-400" />
              <span className="text-lg">{step.text}</span>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.5 }}
          className="mt-8"
        >
          <div className="flex justify-center gap-2">
            {[0, 1, 2].map((dot) => (
              <motion.div
                key={dot}
                animate={{ scale: [1, 1.2, 1] }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  delay: dot * 0.2
                }}
                className="w-2 h-2 bg-green-400 rounded-full"
              />
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LoadingSpinner;